import { useGetCompanies } from '@services/companies'
import {
  ChargingPointDetailStatusColor,
  IChargingPoint,
} from '@services/device'
import { Empty } from 'antd'
import cx from 'classnames'
import { pathOr } from 'ramda'

type IParkingSpaceProps = {
  onClick?: () => void
  data?: IChargingPoint
}

const ParkingSpace = (props: IParkingSpaceProps) => {
  const { onClick, data } = props
  const { byId: orgSessionById } = useGetCompanies()
  return data ? (
    <div
      className={cx('flex flex-col', {
        'cursor-pointer': !!onClick,
      })}
      onClick={() => onClick && onClick()}>
      <div className="w-140 h-120 flex-row-reverse flex">
        {data.connectors
          ?.sort((a, b) => (a.connectorId ?? 0) - (b.connectorId ?? 0))
          ?.map((connector, index) => (
            <div
              key={connector.id}
              style={{
                backgroundColor:
                  ChargingPointDetailStatusColor[
                    connector.detailedStatus || 'Unavailable'
                  ],
              }}
              className={cx('flex-1 border border-white inline-block', {})}>
              {connector.lprNo && (
                <div className="text-sm text-white text-center font-bold">
                  <div>{connector.lprNo}</div>
                  <div>
                    {pathOr(
                      '',
                      [connector.orgSessionId || -1, 'name'],
                      orgSessionById
                    )}
                  </div>
                  <div>{connector.chargingPercentage}%</div>
                </div>
              )}
            </div>
          ))}
      </div>
      <div className="h-30 w-full border border-white text-white text-center">
        {data.displayName}
      </div>
    </div>
  ) : (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="無充電樁資訊" />
  )
}

export default ParkingSpace
